import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import config from "./config";
import apis from "./../apis";
const { psotBotQywxLoginRequest, getBotQywxAuthUrlRequest } = apis;
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
    ...config,
    routes
});

router.beforeEach((to, from, next) => {
    if (window.location.host == 'case.mrstage.com' || window.location.host == 'case-test.mrstage.com') {
        if (to.path == '/') {
            router.push({
                path: '/casebrands'
            })
        }
    }
    next();
    if (to.meta) {
        document.title = to.meta.title;
    }
});

export default router;
